import React, { useState } from "react"
import { Button, Upload, message } from "antd"
import { PaperClipOutlined, DeleteOutlined } from "@ant-design/icons"
import { UPLOAD_FILE } from "../../rest-api/mutations/upload"
import { MEDIA_URL } from "../../utils/config"

// tog'a 1141 (2026-09-04): pulga (Доход) tasdiqlovchi hujjat biriktirish — PDF/rasm/skan (hisob raqamga pul tushgani).
// Fayl darhol serverga yuklanadi (Upload), yo'li form maydoniga yoziladi; jadvalda «Файл» ustunida ochiladi.
export default function FileAttach({ value, onChange }: { value?: string; onChange?: (v: string | undefined) => void }) {
  const [loading, setLoading] = useState(false)
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
      <Upload
        showUploadList={false}
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
        beforeUpload={async (file) => {
          if (file.size / 1024 / 1024 > 15) { message.error("Файл больше 15 МБ"); return false }
          setLoading(true)
          try {
            const fd = new FormData(); fd.append("file", file)
            const r: any = await UPLOAD_FILE(fd)
            const path = r?.path || r?.fileName || r?.Path || r?.FileName
            if (!path) throw new Error("path")
            onChange && onChange(path)
            message.success("Файл прикреплён")
          } catch { message.error("Не удалось загрузить файл") }
          setLoading(false)
          return false
        }}
      >
        <Button icon={<PaperClipOutlined />} loading={loading}>{value ? "Заменить файл" : "Прикрепить файл"}</Button>
      </Upload>
      {value && (
        <>
          <a href={`${MEDIA_URL}${value}`} target="_blank" rel="noreferrer" style={{ maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            📎 {String(value).split("/").pop()}
          </a>
          <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={() => onChange && onChange(undefined)} />
        </>
      )}
    </div>
  )
}
